import React from 'react';

interface SectionProps {
  left: React.ReactNode;
  right: React.ReactNode;
  className?: string;
}

const Section = ({ left, right, className = '' }: SectionProps) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-12 gap-6 ${className}`}>
      <div className="md:col-span-3">{left}</div>
      <div className="md:col-span-9">{right}</div>
    </div>
  );
};

export default Section;
